import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.js'

interface Props { children: React.ReactNode }

export function ProtectedRoute({ children }: Props) {
  const { user, isLoading } = useAuth()
  if (isLoading) return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin h-8 w-8 border-2 border-purple-500 border-t-transparent rounded-full" />
    </div>
  )
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}
